import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultConfig,
  RainbowKitProvider,
  darkTheme
} from '@rainbow-me/rainbowkit';

// IMPORT DOMPET YANG MASIH DIDUKUNG DI VERSI TERBARU
import {
  trustWallet,
  bitgetWallet,
  okxWallet,
  metaMaskWallet,
  injectedWallet,
  walletConnectWallet,
  rabbyWallet
} from '@rainbow-me/rainbowkit/wallets';

import { WagmiProvider, http } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const config = getDefaultConfig({
  appName: 'OFC DApp',
  projectId: '7fd3032ad78d53b4e016839c8b49b75e', 
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [
        trustWallet,
        bitgetWallet,
        okxWallet,
        metaMaskWallet,
        injectedWallet,
        walletConnectWallet,
        rabbyWallet
        // Binance Wallet dihapus karena sudah tidak ada di versi terbaru.
        // Pengguna Binance Web3 akan otomatis terbaca lewat injectedWallet.
      ],
    },
  ],
  chains: [bsc],
  transports: {
    [bsc.id]: http('https://rpc.ankr.com/bsc/80356e80b9423592e3fa81fb7cdbeb62ee0f6c197bb5e70964e8f22d5fd5d0fc') 
  },
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={darkTheme({
          accentColor: '#ffffff',
          accentColorForeground: '#000000',
        })}>
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);